module.exports = __webpack_public_path__ + "aff53da64644ac75c5076b6736aed371.png";